import { api } from "../app/endpoints";

export const fetchSocialLinks = () =>
  fetch(api.socialLinks).then((res) => res.json());
